export default "__VITE_ASSET__ClpLquev__"